<ng-template #loadingOrError>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>

<ng-container *ngIf="!isLoading && !isError else loadingOrError">
	<div class="container-block">
		<div class="container-inner-block">
			<div class="copo-container header-block">
				<div class="copo-section-body copo-grid">
					<div class="copo-grid-row">
						<div class="copo-grid-row-column width-content">
							<div class="card-content-info">
								<div class="card-content-label" translate>offers.create.details.customer.offer-name</div>
								<div class="card-content-value width-content "
									[matTooltip]="form.getFormRfqRef().value">
									{{ form.getFormRfqRef().value }}
								</div>
							</div>
						</div>
						<div class="copo-grid-row-column width-content">
							<div class="card-content-info">
								<div class="card-content-label" translate>eoffer.customer</div>
								<div class="card-content-value width-content" [matTooltip]="soldTo ? soldTo : UNDERSCORE">
									{{ soldTo ? soldTo : UNDERSCORE }} </div>
							</div>
						</div>
						<div class="copo-grid-row-column width-content">
							<div class="card-content-info">
								<div class="card-content-label" translate>eoffer.wizard.delivery.address</div>
								<div class="card-content-value width-content" [matTooltip]="shipTo ? shipTo : UNDERSCORE">
									{{ shipTo ? shipTo : UNDERSCORE }} </div>
							</div>
						</div>
						<div class="copo-grid-row-column width-content">
							<div class="card-content-info">
								<div class="card-content-label" translate>eoffer.create.enduser</div>
								<div class="card-content-value width-content" [matTooltip]="endUser ? endUser : UNDERSCORE">
									{{ endUser ? endUser : UNDERSCORE }} </div>
							</div>
						</div>
					</div>
				</div>
				<div class="copo-section-body copo-grid">
					<div class="copo-grid-row">
						<div class="copo-grid-row-column width-content">
							<div class="card-content-info">
								<div class="card-content-label" translate>eoffer-Period.type</div>
								<div class="card-content-value width-content" [matTooltip]="selectedPeriodTypeDisplay ? selectedPeriodTypeDisplay : UNDERSCORE">
									{{ selectedPeriodTypeDisplay }} </div>
							</div>
						</div>
						<div *ngIf="selectedPeriodDisplay !== ''" class="copo-grid-row-column width-content">
							<div class="card-content-info">
								<div class="card-content-label" translate>eoffer-Period.label</div>
								<div class="card-content-value width-content" [matTooltip]="selectedPeriodDisplay">
									{{ selectedPeriodDisplay }} </div>
							</div>
						</div>
						<div class="copo-grid-row-column width-content">
							<p class="selected-period-display">
								<span translate>eoffer-selected.period</span>:
								<b>{{ selectedPeriodDateDisplay }}</b>
							</p>
						</div>
						<div *ngIf="selectedPeriodDisplay === ''" class="copo-grid-row-column" >
						</div>
						<div class="copo-grid-row-column additional-div" >
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>
<ng-container *ngIf="form.getFormProducts().length > 0; else noProducts;">
	<form novalidate autocomplete="off" [formGroup]="form">
		<ng-container *ngFor="let productFamily of getProductFamiliesHavingItemInCart; let isFirst = first">
			<ng-container *ngIf="productFamily.code">
				<div class="copo-container cart-title">
					<div class="cart-title-heading"> <span *ngIf="isFirst" translate>eorder.wizard.product.modification.title.cart</span> </div>
					<div class="cart-title-content"> {{getProductsCountBySubCategory(productFamily.code)}} <span translate>eorder.wizard.product.modification.title.items</span> </div>
					<div class="cart-product-family">
						<span class="pf-sub-category">{{productFamily?.subCategoryDescription}}</span>
						<span class="pf-form">&nbsp;({{productFamily?.formDescription  | titlecase}})</span>
					</div>
				</div>
				<ng-container *ngIf="templatesInLoading.size === 0 && productFamily.code; else loadingOrError">
					<div class="grid-column-one-full card-block">
						<div formArrayName="products">
							<ng-container *ngFor="let product of productResultControl(productFamily); let i=index">
								<ng-container *ngIf="product.get('uniqueRef')?.value as uniqueRef">
									<div @deleteItemTrigger class="card-product-block" [formGroupName]="getProductIndexByUniqueRef(uniqueRef)" #rows>
										<div *ngIf="product.get('configErrMsg')?.value !== ''" class="card-block copo-notification-block">
											<mat-icon svgIcon="alert" [attr.title]="'quapp.alert' | translate" class="copo-notification-icon copo-hint-warning wrap-error"></mat-icon>
											<div>
												<div class="card-header-label"> <b translate>eorder.wizard.product.itemnumber</b> &nbsp;<b>{{ i + 1 + getPreviousFamiliesItemCount(productFamily.code) | number: '3.' }}</b></div>
													{{product.get('configErrMsg')?.value}}
											</div>
										</div>
										<div class="card-header copo-dark-theme" 
										[ngClass]="[getExpandPanelStatus(productFamily.code, i) && !isFullyConfigured(product.get('productType')?.value) ? 'card-header-top-rounded':'card-header-rounded']">
											<div class="card-header-label card-header-div-block">
												<div class="header-label" translate>eorder.wizard.product.itemnumber</div>
												<div class="field-value"><span>{{ i + 1 + getPreviousFamiliesItemCount(productFamily.code) | number: '3.' }}</span></div>
											</div>
											<!-- Steelgrade -->
											<mat-form-field *ngIf="!isFullyConfigured(product.get('productType')?.value) && isVariable(product.get('templateNumber')?.value, 'steelGrade') else steelGradReadonly" subscriptSizing="dynamic" floatLabel="always">
												<mat-label translate>eorder.wizard.product.steelgrade</mat-label>
												<mat-select class="steel-grade-text-color" formControlName="steelGrade"
													[value]="product.get('steelGrade')?.value" [compareWith]="compareWithFn"
													(selectionChange)="simulationCallOnValueChange(uniqueRef, product)"
													[@appearAnimation]="getVariableFieldUpdatedState(uniqueRef, 'steelGrade') ? 'highlight' : ''">
													<mat-option *ngIf="checkIfConfigValueInVariableList('steelGrade', product.get('configurationNumber')?.value, getPossibleValues('steelGrade', product.get('templateNumber')?.value))" [value]="getConfigValue('steelGrade', product.get('configurationNumber')?.value)"
														[matTooltip]="getTranslationForCodeByIndex('steelGrade', product.get('configurationNumber')?.value)">
														<span>{{getTranslationForCodeByIndex('steelGrade', product.get('configurationNumber')?.value)}}</span>
													</mat-option>
													<mat-option *ngFor="let variableField of getPossibleValues('steelGrade', product.get('templateNumber')?.value)| copoSortOptions:false: variableconfig" [value]="variableField.code">
														<span>{{ variableField.value }}</span>
													</mat-option>
												</mat-select>
											</mat-form-field>
											<ng-template #steelGradReadonly>
												<div class="card-header-label card-header-div-block">
													<div class="header-label" translate>eorder.wizard.product.steelgrade</div>
													<div class="field-value" [matTooltip]="getSteelGradeDescription(uniqueRef)" [@appearAnimation]="getVariableFieldUpdatedState(uniqueRef, 'steelGrade') ? 'highlight' : ''">
														<span>{{getSteelGradeDescription(uniqueRef)}}</span>
													</div>
												</div>
											</ng-template>
				
											<!-- Thickness -->
											<mat-form-field *ngIf="!isFullyConfigured(product.get('productType')?.value) && isVariable(product.get('templateNumber')?.value, 'thicknessValue') else thicknessReadonly" subscriptSizing="dynamic" floatLabel="always">
												<mat-label translate>eorder.wizard.product.thickness</mat-label>
												<input matInput type="number" copoInputNumber formControlName="thicknessValue"
													[min]="0" [decimalCount]="3" [formControl]="getFormControl(product.get('thicknessValue'))" step="0.01" class="input-field-text"
													(change)="simulationCallOnValueChange(uniqueRef, product)"
													[@appearAnimation]="getVariableFieldUpdatedState(uniqueRef, 'thicknessValue') ? 'highlight' : ''">
												<mat-icon matSuffix class="pencil-icon pencil-icon-white" svgIcon="copo_pencil"></mat-icon>
											</mat-form-field>
											<ng-template #thicknessReadonly>
												<div class="card-header-label card-header-div-block">
													<div class="header-label" translate>eorder.wizard.product.thickness</div>
													<div class="field-value" [matTooltip]="product.get('thicknessValue')?.value" [@appearAnimation]="getVariableFieldUpdatedState(uniqueRef, 'thicknessValue') ? 'highlight' : ''">
														<span>{{product.get('thicknessValue')?.value}}</span>
													</div>
												</div>
											</ng-template>
				
											<!-- Width -->
											<mat-form-field *ngIf="!isFullyConfigured(product.get('productType')?.value) && isVariable(product.get('templateNumber')?.value, 'widthValue') else widthReadonly" subscriptSizing="dynamic" floatLabel="always">
												<mat-label translate>eorder.wizard.product.width</mat-label>
												<input matInput class="input-field-text" type="number" formControlName="widthValue"
												copoInputNumber [min]="1" [decimalCount]="0" [formControl]="getFormControl(product.get('widthValue'))"
												(change)="simulationCallOnValueChange(uniqueRef, product)"
												[@appearAnimation]="getVariableFieldUpdatedState(uniqueRef, 'widthValue') ? 'highlight' : ''">
												<mat-icon matSuffix class="pencil-icon pencil-icon-white" svgIcon="copo_pencil"></mat-icon>
											</mat-form-field>
											<ng-template #widthReadonly>
												<div class="card-header-label card-header-div-block">
													<div class="header-label" translate>eorder.wizard.product.width</div>
													<div class="field-value" [matTooltip]="product.get('widthValue')?.value"
													[@appearAnimation]="getVariableFieldUpdatedState(uniqueRef, 'widthValue') ? 'highlight' : ''">
														<span>{{product.get('widthValue')?.value}}</span>
													</div>
												</div>
											</ng-template>
				
											<!-- Length -->
											<mat-form-field subscriptSizing="dynamic" *ngIf="isSheet(product.get('form')?.value) && !isFullyConfigured(product.get('productType')?.value) && isVariable(product.get('templateNumber')?.value, 'lengthValue') else lengthReadonly" floatLabel="always">
												<mat-label translate>batch.length</mat-label>
												<input matInput class="input-field-text" type="number" formControlName="lengthValue"
												copoInputNumber [min]="1" [decimalCount]="0" [formControl]="getFormControl(product.get('lengthValue'))"
												(change)="simulationCallOnValueChange(uniqueRef, product)"
												[@appearAnimation]="getVariableFieldUpdatedState(uniqueRef, 'lengthValue') ? 'highlight' : ''">
												<mat-icon class="pencil-icon pencil-icon-white" svgIcon="copo_pencil" matSuffix></mat-icon>
											</mat-form-field>
											<ng-template #lengthReadonly>
												<div *ngIf="isSheet(product.get('form')?.value)" class="card-header-label card-header-div-block">
													<div class="header-label" translate>batch.length</div>
													<div class="field-value" [matTooltip]="product.get('lengthValue')?.value"
													[@appearAnimation]="getVariableFieldUpdatedState(uniqueRef, 'lengthValue') ? 'highlight' : ''">
														<span>{{product.get('lengthValue')?.value}}</span>
													</div>
												</div>
											</ng-template>
				
											<div class="card-header-right card-action-block">
												<div class="status-icon-group" *ngIf="product.get('loader')?.value !== 'true'; else simulationLoading">
													<mat-icon [class]="getSimulationStatus(product.get('isSimulationCompleted')?.value, product.get('configErrMsg')?.value)" svgIcon="icon-status"></mat-icon>
												</div>
												<button type="button" mat-icon-button *ngIf="product.get('isSimulationCompleted')?.value === 'true' else closedEye" class="card-container-column card-column-eye"><mat-icon class="copo-eye-closed copo-eye-icon-open" svgIcon="open_eye"></mat-icon></button>
												<ng-template #closedEye>
													<div class="card-column-eye">
														<mat-icon class="copo-eye-closed eye-closed-icon-white" svgIcon="closed_eye"></mat-icon>
													</div>
												</ng-template>
												<button type="button" mat-icon-button [matMenuTriggerFor]="menu">
													<mat-icon svgIcon="md:more_vert"></mat-icon>
												</button>
												<mat-menu #menu="matMenu" xPosition="before" yPosition="below">
													<button type="button" mat-menu-item [disabled]="product.get('loader')?.value === 'true'" (click)="removeProduct(uniqueRef, productFamily.code, i)"><span translate>eorder.wizard.product.action.delete</span>
													</button>
													<button type="button" mat-menu-item [disabled]="product.get('loader')?.value === 'true'" (click)="resetProduct(uniqueRef)"><span translate>filter.reset</span>
													</button>
													<button type="button" mat-menu-item [disabled]="product.get('loader')?.value === 'true' || disableDuplicateMenu()" (click)="duplicateProduct(uniqueRef, productFamily.code)"><span translate>eorder.wizard.product.action.duplicate</span>
													</button>
												</mat-menu>
												<div *ngIf="!isFullyConfigured(product.get('productType')?.value)">
													<button type="button" mat-icon-button>
														<mat-icon [ngClass]="getExpandPanelStatus(productFamily.code, i)?'':'drop-down-rotate'"
															svgIcon="copo_dropdown" (click)="expandPanel(productFamily.code, i)"></mat-icon>
													</button>
												</div>
											</div>
										</div>
										<mat-expansion-panel *ngIf="!isFullyConfigured(product.get('productType')?.value)" [expanded]="getExpandPanelStatus(productFamily.code, i)">
											<ng-template matExpansionPanelContent>
												<div class="card-content-variables">
													<!-- variable fields -->
													<ng-container *ngIf="getVariablesForThirdRow(product.get('templateNumber')?.value).length > 0" formGroupName="variableFormGroup">
														<div *ngFor="let field of getVariablesForThirdRow(product.get('templateNumber')?.value)" [ngClass]="field.hidden ?'hidden-field':''">
															<mat-form-field subscriptSizing="dynamic" *ngIf="field.type === 'number' " class="copo-content-product card-header-double-span copo-form-field">
																<mat-label>{{getFieldLabel(field.keys)}}</mat-label>
																<input matInput
																copoInputNumber
																[formControlName]="field.keys"
																[formControl]="getVariableFormGroupControl(uniqueRef, field.keys)"
																[min]="0"
																[max]="99999.9999"
																type="number"
																class="input-field"
																(change)="simulationCallOnValueChange(uniqueRef, product)"
																[@appearAnimation]="getVariableFieldUpdatedState(uniqueRef, field.keys) ? 'highlight' : ''">
																<mat-icon class="pencil-icon pencil-icon-red" svgIcon="copo_pencil" matSuffix></mat-icon>
															</mat-form-field>
															<ng-container *ngIf="field.type === 'string' && field.freeType === true " >
																<mat-form-field subscriptSizing="dynamic" class="copo-content-product card-header-double-span copo-form-field">
																	<mat-label>{{getFieldLabel(field.keys)}}</mat-label>
																	<input matInput
																	[formControlName]="field.keys"
																	type="text"
																	maxlength="30"
																	class="input-field"
																	(change)="simulationCallOnValueChange(uniqueRef, product)"
																	[@appearAnimation]="getVariableFieldUpdatedState(uniqueRef, field.keys) ? 'highlight' : ''">
																	<mat-icon class="pencil-icon pencil-icon-red" svgIcon="copo_pencil" matSuffix></mat-icon>
																</mat-form-field>
															</ng-container>
															<div class="multi-input-group" *ngIf="field.type === 'array'">
																<ng-container *ngIf="field.freeType === false else multiInputFields" [formArrayName]="field.parentVariableName">
																	<div *ngFor="let x of getVariableFormArray(uniqueRef, field.parentVariableName); let j=index; let last=last;">
																		<mat-form-field subscriptSizing="dynamic" class="copo-content-product card-header-double-span copo-form-field">
																			<mat-label>{{getFieldLabel(field.keys)}}</mat-label>
																			<mat-select [formControlName]="j" [value]="getVariableFormArrayValueByIndex(uniqueRef, j, field.parentVariableName)" [compareWith]="compareWithFn"
																			(selectionChange)="simulationCallOnValueChange(uniqueRef, product)"
																			[@appearAnimation]="getVariableFieldUpdatedState(uniqueRef, field.keys, j) ? 'highlight' : ''">
																				<mat-option *ngIf="checkIfConfigValueInVariableListMultiItems(field.keys, uniqueRef, j, field.parentVariableName, field.values)" [value]="getConfigValueMultiItems(field.keys, uniqueRef, j, field.parentVariableName)"
																					[matTooltip]="getTranslationForCodeByIndexMultiItems(field.keys, uniqueRef, j, field.parentVariableName)">
																					<span>{{getTranslationForCodeByIndexMultiItems(field.keys, uniqueRef, j, field.parentVariableName)}}</span>
																				</mat-option>
																				<mat-option *ngFor="let variableField of field.values| copoSortOptions:false: variableconfig" [value]="variableField.code"
																					[matTooltip]="variableField.value">
																					<span>{{variableField.value}}</span>
																				</mat-option>
																			</mat-select>
																			<div [ngClass]="field.maxItems && field.maxItems > 1 && last && j !== 0 && last && j < (field.maxItems - 1) ? 'multi-input-button-group-3' :'multi-input-button-group-2'" matSuffix tabindex="-1">
																				<button type="button" mat-icon-button (click)="$event.stopPropagation(); resetVariableFormArrayValueByIndex(uniqueRef, j, field.parentVariableName)">
																					<mat-icon class="remove-icon-style" svgIcon="md:close"></mat-icon>
																				</button>
																				<ng-container *ngIf="field.maxItems && field.maxItems > 1">
																					<button *ngIf="last && j !== 0" type="button" mat-icon-button (click)="$event.stopPropagation(); removeFieldFromVariableFormArray(uniqueRef, j, field.parentVariableName)">
																						<mat-icon class="remove-icon-style" svgIcon="remove"></mat-icon>
																					</button>
																					<button *ngIf="last && j < (field.maxItems - 1)" type="button" mat-icon-button (click)="$event.stopPropagation(); addFieldToVariableFormArray(uniqueRef, field.maxItems, field.parentVariableName, field.mandatory, field.hidden)">
																						<mat-icon class="copo-icon-style" svgIcon="plus"></mat-icon>
																					</button>
																				</ng-container>
																			</div>
																		</mat-form-field>
																	</div>
																</ng-container>
																<ng-template  #multiInputFields>
																	<ng-container [formArrayName]="field.keys">
																		<div [ngClass]="field.maxItems && field.maxItems > 1 && last ? (j !== 0 && j < (field.maxItems - 1) ? 'drop-down-group-3' : 'drop-down-group-2'):'drop-down-group-1'" *ngFor="let x of getVariableFormArray(uniqueRef, field.parentVariableName); let j=index; let last=last;">
																			<mat-form-field subscriptSizing="dynamic" class="copo-content-product card-header-double-span copo-form-field">
																				<mat-label>{{getFieldLabel(field.keys)}}</mat-label>
																				<input matInput
																				[formControlName]="j"
																				type="text"
																				maxlength="30"
																				class="input-field"
																				(change)="simulationCallOnValueChange(uniqueRef, product)"
																				[@appearAnimation]="getVariableFieldUpdatedState(uniqueRef, field.keys, j) ? 'highlight' : ''">
																				<mat-icon class="pencil-icon pencil-icon-red" svgIcon="copo_pencil" matSuffix></mat-icon>
																				<div [ngClass]="field.maxItems && field.maxItems > 1 && last && j !== 0 && last && j < (field.maxItems - 1) ? 'multi-input-button-group-2' :''" matSuffix tabindex="-1">
																					<ng-container *ngIf="field.maxItems && field.maxItems > 1">
																						<button *ngIf="last && j !== 0" type="button" mat-icon-button (click)="$event.stopPropagation(); removeFieldFromVariableFormArray(uniqueRef, j, field.parentVariableName)">
																							<mat-icon class="remove-icon-style" svgIcon="remove"></mat-icon>
																						</button>
																						<button *ngIf="last && j < (field.maxItems - 1)" type="button" mat-icon-button (click)="$event.stopPropagation(); addFieldToVariableFormArray(uniqueRef, field.maxItems, field.parentVariableName, field.mandatory, field.hidden)">
																							<mat-icon class="copo-icon-style" svgIcon="plus"></mat-icon>
																						</button>
																					</ng-container>
																				</div>
																			</mat-form-field>
																		</div>
																	</ng-container>
																</ng-template>
															</div>
															<div *ngIf="field.type === 'string' && field.freeType !== true">
																<mat-form-field subscriptSizing="dynamic" class="copo-content-product card-header-double-span copo-form-field">
																	<mat-label>{{getFieldLabel(field.keys)}}</mat-label>
																	<mat-select [formControlName]="field.keys"
																		[value]="getVariableFieldValue(product.get('uniqueRef')?.value, field.keys)" [compareWith]="compareWithFn"
																		(selectionChange)="simulationCallOnValueChange(uniqueRef, product)"
																		[@appearAnimation]="getVariableFieldUpdatedState(uniqueRef, field.keys) ? 'highlight' : ''">
																		<mat-option *ngIf="checkIfConfigValueInVariableList(field.keys, product.get('configurationNumber')?.value, field.values)" [value]="getConfigValue(field.keys, product.get('configurationNumber')?.value)"
																			[matTooltip]="getTranslationForCodeByIndex(field.keys, product.get('configurationNumber')?.value)">
																			<span>{{getTranslationForCodeByIndex(field.keys, product.get('configurationNumber')?.value)}}</span>
																		</mat-option>
																		<mat-option *ngFor="let variableField of field.values| copoSortOptions:false: variableconfig" [value]="variableField.code"
																			[matTooltip]="variableField.value">
																			<span>{{variableField.value}}</span>
																		</mat-option>
																	</mat-select>
																	<button type="button" matSuffix mat-icon-button tabindex="-1" (click)="$event.stopPropagation(); resetVariableFieldValue(uniqueRef, field.keys)">
																		<mat-icon class="remove-icon-style" svgIcon="md:close"></mat-icon>
																	</button>
																</mat-form-field>
															</div>
														</div>
													</ng-container>
												</div>
												<div>
													<!-- optional tolerance fields -->
													<ng-container *ngIf="getOptionalToleranceFields(product.get('templateNumber')?.value).size > 0" formGroupName="variableFormGroup">
														<div class="tolerance-block" *ngFor="let group of getOptionalToleranceFields(product.get('templateNumber')?.value) | keyvalue">
															<div class="tolerance-group">
															<div class="tolerance-standard" *ngIf="group.value[0].type === 'string' && group.value[0].freeType !== true">
																<mat-form-field subscriptSizing="dynamic" class="copo-content-product card-header-double-span copo-form-field">
																	<mat-label>{{getFieldLabel(group.value[0].keys)}}</mat-label>
																	<mat-select [formControlName]="group.value[0].keys"
																		[value]="getVariableFieldValue(uniqueRef, group.value[0].keys)" [compareWith]="compareWithFn"
																		(selectionChange)="simulationCallOnValueChange(uniqueRef, product)"
																		[@appearAnimation]="getVariableFieldUpdatedState(uniqueRef, group.value[0].keys) ? 'highlight' : ''">
																		<mat-option *ngIf="checkIfConfigValueInVariableList(group.value[0].keys, product.get('configurationNumber')?.value, group.value[0].values)" [value]="getConfigValue(group.value[0].keys, product.get('configurationNumber')?.value)"
																			[matTooltip]="getTranslationForCodeByIndex(group.value[0].keys, product.get('configurationNumber')?.value)">
																			<span>{{getTranslationForCodeByIndex(group.value[0].keys, product.get('configurationNumber')?.value)}}</span>
																		</mat-option>
																		<mat-option *ngFor="let variableField of group.value[0].values| copoSortOptions:false: variableconfig" [value]="variableField.code"
																			[matTooltip]="variableField.value">
																			<span>{{variableField.value}}</span>
																		</mat-option>
																	</mat-select>
																	<button type="button" matSuffix mat-icon-button tabindex="-1" (click)="$event.stopPropagation(); resetVariableFieldValue(uniqueRef, group.value[0].keys)">
																		<mat-icon class="remove-icon-style" svgIcon="md:close"></mat-icon>
																	</button>
																</mat-form-field>
															</div>
															<div class="bold-label">
																<span translate>global.or</span>
															</div>
															<div class="tolerance-inner-group">
																<mat-form-field subscriptSizing="dynamic" class="copo-content-product card-header-double-span copo-form-field">
																	<mat-label>{{getFieldLabel(group.value[1].keys)}}</mat-label>
																	<input matInput
																	type="number"
																	copoInputNumber
																	[formControlName]="group.value[1].keys"
																	[formControl]="getVariableFormGroupControl(uniqueRef, group.value[1].keys)"
																	[min]="0"
																	[max]="99999.9999"
																	class="input-field"
																	(change)="simulationCallOnValueChange(uniqueRef, product)"
																	[@appearAnimation]="getVariableFieldUpdatedState(uniqueRef, group.value[1].keys) ? 'highlight' : ''">
																	<mat-icon class="pencil-icon pencil-icon-red" svgIcon="copo_pencil" matSuffix></mat-icon>
																</mat-form-field>
																<mat-form-field subscriptSizing="dynamic" class="copo-content-product card-header-double-span copo-form-field">
																	<mat-label>{{getFieldLabel(group.value[2].keys)}}</mat-label>
																	<input matInput
																	type="number"
																	copoInputNumber
																	[formControlName]="group.value[2].keys"
																	[formControl]="getVariableFormGroupControl(uniqueRef, group.value[2].keys)"
																	[min]="0"
																	[max]="99999.9999"
																	class="input-field"
																	(change)="simulationCallOnValueChange(uniqueRef, product)"
																	[@appearAnimation]="getVariableFieldUpdatedState(uniqueRef, group.value[2].keys) ? 'highlight' : ''">
																	<mat-icon class="pencil-icon pencil-icon-red" svgIcon="copo_pencil" matSuffix></mat-icon>
																</mat-form-field>
															</div>
															</div>
														</div>
													</ng-container>
												</div>
											</ng-template>
										</mat-expansion-panel>
									</div>
								</ng-container>
							</ng-container>
						</div>
					</div>
				</ng-container>
			</ng-container>
		</ng-container>
	</form>
</ng-container>
<ng-template #noProducts>
	<div class="copo-container cart-title">
		<div class="cart-title-heading"> <span translate>eorder.wizard.product.modification.title.cart</span> </div>
		<div class="cart-title-content"><span translate>woe.noitems</span></div>
		<div class="cart-product-family">
			<span class="pf-sub-category">{{UNDERSCORE}}</span>
			<span class="pf-form">&nbsp;({{UNDERSCORE}})</span>
		</div>
	</div>
	<div class="copo-error-label">
		<span translate>eorder.wizard.product.modification.no.products</span>
	</div>
</ng-template>
<ng-template #simulationLoading>
	<copo-loading-spinner class="simulation-loading"></copo-loading-spinner>
</ng-template>